import {useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {
  updateSelectedProperty,
  resetSelectedProperty,
} from '@stencil/hotels-common-reducer/src/actions';

import {commonSelectorFn} from '@stencil/hotels-common-reducer/src/selectors';
import {UPDATE_QUERY, IUpdate_Query} from '@stencil/hotels-common-reducer/src/types';
import autosuggestOnSelectionhandler from '../utils/autosuggestOnSelectionHandler';

export default function useSearchWidget() {
  const dispatch = useDispatch();

  const {checkin, checkout, roomString, destination, country, partner} = useSelector(
    commonSelectorFn,
  );

  const updateQueryCaller = useCallback(
    (actionData: IUpdate_Query['actionData']) => {
      return dispatch({type: UPDATE_QUERY, actionData});
    },
    [dispatch],
  );

  const updatePropertyDetails = useCallback(
    ({propertyId = '', propertyName = '', resetFlag = false}) => {
      if (resetFlag) {
        dispatch(resetSelectedProperty());
      } else {
        dispatch(
          updateSelectedProperty({
            payload: {
              propertyId,
              propertyName,
            },
          }),
        );
      }
    },
    [dispatch],
  );
  // ! might be required if there is explicit product ask to update stuff without user clicking UpdateSearch
  // const updateFilterCaller = useCallback(
  //   (actionData: IUpdate_Filter['actionData']) => {
  //     return dispatch({type: UPDATE_FILTER, actionData});
  //   },
  //   [dispatch],
  // );

  const autosuggestHandler = changes => {
    autosuggestOnSelectionhandler(changes, updateQueryCaller, updatePropertyDetails);
  };

  return {
    checkin,
    checkout,
    roomString,
    country,
    partner,
    destination,
    autosuggestHandler,
    updateQueryCaller,
  };
}
